export default {
	title: 'Collector Config',
	actions: {
		add: 'Add',
		edit: 'Edit',
		copy: 'Copy',
		delete: 'Delete',
		batchDelete: 'Batch Delete'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete the selected {count} records?',
		deleteSuccess: 'Operation successful',
		selectDeleteWarning: 'Please select records to delete',
		operateSuccess: 'Operation successful',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty'
	},
	form: {
		name: 'Name',
		placeholder: {
			name: 'Please enter name'
		}
	},
	table: {
		id: 'ID',
		name: 'Collector Definition Name',
		remark: 'Collector Type'
	},
	dialog: {
		add: 'Add',
		edit: 'Edit',
		copy: 'Copy',
		modelConfig: 'Model Config',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	widgetForm: {
		name: 'Collector Definition Name',
		collectorType: 'Collector Type',
		highFreqAccel: 'High Freq Accel',
		lowFreqAccel: 'Low Freq Accel',
		longWave: 'Long Wave',
		characteristicValue: 'Characteristic Value',
		collectStrategy: 'Collect Strategy',
		configName: 'Config Name',
		configValue: 'Config Value',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty',
		placeholder: {
			name: 'Please enter collector definition name'
		}
	},
	collectorType: {
		singleAxisSensor: 'Single Axis Sensor',
		threeAxisSensor: 'Three Axis Sensor'
	},
	configItem: {
		collectLength: 'Collect Length',
		collectFreq: 'Collect Freq',
		collectInterval: 'Collect Interval',
		zAxisCollectLength: 'Z Axis Collect Length',
		xyAxisCollectLength: 'X/Y Axis Collect Length',
		zAxisCollectFreq: 'Z Axis Collect Freq',
		xyAxisCollectFreq: 'X/Y Axis Collect Freq'
	},
	lengthOptions: {
		'1K': '1K',
		'2K': '2K',
		'4K': '4K',
		'8K': '8K',
		'16K': '16K',
		'32K': '32K',
		'64K': '64K',
		'128K': '128K',
		'256K': '256K',
		'512K': '512K'
	},
	freqOptions: {
		'2560': '2560',
		'5120': '5120',
		'12800': '12800',
		'25600': '25600',
		'51200': '51200'
	},
	intervalOptions: {
		'30': '30',
		'60': '60',
		'300': '300',
		'600': '600',
		'1800': '1800',
		'3600': '3600'
	},
	collectStrategy: {
		speedCollect: 'Speed Collect',
		abnormalEncryptCollect: 'Abnormal Encrypt Collect'
	}
}
